/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomBuildDifferenceTrendRequest extends models.AppSecopsTimeRangeFilter {
    getFixupPrototypeFunction() { return AppSecopsSbomBuildDifferenceTrendRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomBuildDifferenceTrendRequest>): AppSecopsSbomBuildDifferenceTrendRequest {
        let obj = Object.assign(new AppSecopsSbomBuildDifferenceTrendRequest(), model);
        AppSecopsSbomBuildDifferenceTrendRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomBuildDifferenceTrendRequest>): AppSecopsSbomBuildDifferenceTrendRequest {
        if (!model) return null;
        return AppSecopsSbomBuildDifferenceTrendRequest.newInstance(<AppSecopsSbomBuildDifferenceTrendRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomBuildDifferenceTrendRequest) {
        if (!obj) return;

        models.AppSecopsSbomBuildDifferenceTrendRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomBuildDifferenceTrendRequest): boolean {
        if (models.AppSecopsTimeRangeFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomBuildDifferenceTrendRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
